import CommissionRateItem from '../../../Domain/CommissionRateItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CommissionLineService from '../../../Services/CommissionLineService';

export default class EditCommissionLineWindowDescription {
  static titleForCreate = 'Add New Commission Line';
  static titleForEdit = (editedItem) => `Edit COmmission Line #${editedItem.CommissionLineId}`;
  static itemType = CommissionRateItem;
  static serviceFunction = CommissionLineService.UpsertItem;

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CommissionedUserId',
          label: 'Commissioned User',
          className: 'col-4',
          type: InputTypesEnum.CommissionUserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CurrencyId',
          label: 'Currency',
          className: 'col-4',
          type: InputTypesEnum.ActiveCurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CommissionValue',
          label: 'Commission Value',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ClientId',
          label: 'Client',
          className: 'col-6',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ServiceId',
          label: 'Service',
          className: 'col-6',
          type: InputTypesEnum.ActiveServiceSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.forRequiredSelectField,
          disabled: (item) => !item.ClientId,
        },
        {
          fieldName: 'Comments',
          label: 'Comments',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];

  static getCommissionYearOptions() {
    //If changes are made here, EditServiceDescription.getCommissionYearOptions should be updated accordingly
    return [
      { value: null, label: 'Choose one...' },
      { value: 1, label: 'Year 1' },
      { value: 2, label: 'Year 2' },
    ];
  }
}
